import { isEmpty, camelCase, upperFirst } from 'lodash'
import pluralize from 'pluralize'
import MagnificPopup from './magnific_popup'
import FormFilter from './form_filter'
import Modal from './modal'
import Helper from '../helpers/helper'
import { useEffect, useRef } from 'react'
import { createRoot } from 'react-dom/client'
import { isColorLegendSingleAccount } from './object_color_legend_select'
import Dropdown from './dropdown'

export const deideize = (str) => (str.endsWith('_id') ? str.slice(0, -3) : str)

export const camelize = (str) => upperFirst(camelCase(str))

export const toClassName = (str) => camelize(deideize(str))

export function fetchFilters() {
  if (!this.props.settings.filter_disabled && !this.props.read_only) {
    const kind = this.props.settings.filter_name || pluralize(this.props.settings.type)
    const _this = this

    jQuery.ajax({
      method: 'GET',
      url: window.appData.api_filters_path,
      data: {
        kind: kind,
        scope_type: this.props.scope_type,
        scope_id: this.props.scope_id,
        with_current: this.props.filters_with_current
      },
      success: (data) => {
        _this.setState({ filters: data })
      }
    })
  }
}

export function collapsableList(items, itemsVisible) {
  if (items.length > itemsVisible) {
    let trigger = (
      <div className="toggle-collapse"></div>
    )
    return (
      <>
        {items.slice(0, itemsVisible)}
        <Dropdown trigger={trigger} children={items} triggerClassName='collapse-btn-wrap' />
      </>
    )
  } else {
    return items
  }
}

export function markdownify(text) {
  if (!text) return text

  //replace the linebreaks with <br>
  text = text.replace(/(?:\r\n|\r|\n)/g, '<br>')

  //check for links [text](url)
  let elements = text.match(/\[.*?\)/g)
  if (elements != null && elements.length > 0) {
    elements.map((el) => {
      let txt = el.match(/\[(.*?)\]/)[1] //get only the txt
      let url = el.match(/\((.*?)\)/)[1] //get only the link
      text = text.replace(el, '<a href="' + url + '" target="_blank">' + txt + '</a>')
    })
  }

  return <span dangerouslySetInnerHTML={{ __html: text }}></span>
}

export function capitalize(str) {
  if (str == null || str == undefined) return null
  var frags = str.split('_')
  frags.forEach((frag, i) => {
    frags[i] = frag.charAt(0).toUpperCase() + frag.slice(1)
  })
  return frags.join('')
}

export function useDidMountEffect(func, deps) {
  const didMount = useRef(false)

  useEffect(() => {
    if (didMount.current) func()
    else didMount.current = true
  }, deps)
}

export function getMonthName(monthNumber) {
  return titleCase(moment(new Date(2000, parseInt(monthNumber) - 1, 1)).format('MMMM'))
}

export function usePrevious(value) {
  const ref = useRef()
  useEffect(() => {
    ref.current = value
  })
  return ref.current
}

export function toggleFilter(well = false, e = undefined) {
  if (!(well && this.state.filterOpened)) {
    if (e) e.preventDefault()
    this.setState({ filterOpened: !this.state.filterOpened })
  }
}

export function handleSubmitFilter(e) {
  e.preventDefault()
}

export function updateColumnVisibility(col_name, value) {
  if (this.props.read_only || !this.props.settings.update_visibility_url) return
  jQuery.ajax({
    method: 'PATCH',
    url: this.props.settings.update_visibility_url,
    data: {
      col_name: col_name,
      hidden: value,
      object: this.props.settings.visibility_columns_type || this.props.settings.type
    }
  })
}

export function handleChangeNegatedFilter(column_name) {
  let negatedFilters = this.state.filter.negated_filters ? this.state.filter.negated_filters.concat() : []
  let newNegatedFilters = []

  if (negatedFilters.includes(column_name)) {
    newNegatedFilters = negatedFilters.filter((name) => name != column_name)
  } else {
    newNegatedFilters = negatedFilters.concat([column_name])
  }

  this.setState({
    filter: Object.assign({}, this.state.filter, { negated_filters: newNegatedFilters, filterId: undefined }),
    activeFilterUUID: '',
    page: 1
  })
}

export function handleChangeAndOrFilter(column_name) {
  let andOrFilters = this.state.filter.and_or_filters ? this.state.filter.and_or_filters.concat() : []
  let newAndOrFilters = []

  if (andOrFilters.includes(column_name)) {
    newAndOrFilters = andOrFilters.filter((name) => name != column_name)
  } else {
    newAndOrFilters = andOrFilters.concat([column_name])
  }

  this.setState({
    filter: Object.assign({}, this.state.filter, { and_or_filters: newAndOrFilters, filterId: undefined }),
    activeFilterUUID: '',
    page: 1
  })
}
export function handleChangeDescriptionFilter() {
  this.setState({
    filter: Object.assign({}, this.state.filter, {
      search_in_description: !this.state.filter.search_in_description,
      filterId: undefined
    }),
    activeFilterUUID: '',
    page: 1
  })
}

export function rangeArray(start, end) {
  return Array.from({ length: end + 1 - start }, (v, k) => k + start)
}

function ensureFilterIntegrity(oldFilterState) {
  const ret = { ...oldFilterState }

  // ENSURE: color_legend is undefined when - multiple accounts are filtered && account specific legend is selected
  if ('account_ids' in ret) {
    if (isColorLegendSingleAccount(ret.color_legend)) {
      const isCrossAccount = isEmpty(ret.account_ids) || ret.account_ids.includes(',')
      if (isCrossAccount) {
        ret.color_legend = ''
      }
    }
  }

  return ret
}

export function handleFilterInputChange(e) {
  let h
  if (e.target.selectedOptions) {
    let selectedValues = Array.from(e.target.selectedOptions).map((option) => option.value)
    // NOTE: we force string format of array avoid polymorphic data format, polymorphic data format is BAD PRACTICE
    h = { [e.target.name]: selectedValues.join(',') }
  } else if (e.target.type == 'checkbox') {
    h = { [e.target.name]: e.target.checked }
  } else {
    h = { [e.target.name]: e.target.value }
  }

  const filter = ensureFilterIntegrity({
    ...this.state.filter,
    ...h,
    filterId: undefined
  })

  this.setState({ filter, activeFilterUUID: '', page: 1 })

  // this.setState({
  //   filter: Object.assign({}, this.state.filter, h, { filterId: undefined }),
  //   activeFilterUUID: '',
  //   page: 1
  // })
}

export function titleCase(string) {
  return string[0].toUpperCase() + string.slice(1).toLowerCase()
}

export function handleFilterDatepickerChange(data) {
  let h = {}
  h[`${data.column.name}_period`] = data.period
  h[data.column.start_date_name] = data.startDate
  h[data.column.end_date_name] = data.endDate

  this.setState({
    filter: Object.assign({}, this.state.filter, h, { filterId: undefined }),
    activeFilterUUID: '',
    page: 1
  })
}

export function handleClearFilter(e) {
  if (e) {
    e.preventDefault()
    e.target.blur()
  }
  let h = { search: '', search_not: '', and_or_filters: [], negated_filters: [], kanban_columns: [] }

  // Columns
  if (this.props.settings.filter.columns) {
    this.props.settings.filter.columns.forEach((i) => {
      if (i.format == 'range') {
        h[i.start_date_name] = ''
        h[i.end_date_name] = ''
        h[`${i.name}_period`] = ''
      } else if (i.format == 'number_range') {
        h[i.from_name] = ''
        h[i.to_name] = ''
      } else {
        h[i.name] = ''
      }
    })
  }

  // Booleans
  if (this.props.settings.filter.booleans) {
    this.props.settings.filter.booleans.forEach((i) => {
      h[i.name] = false
    })
  }

  this.setState({ filter: h, page: 1, activeFilterUUID: '', columns_order: null, columns_visibility: null }, () => {
    window.select2()
  })
}

export function hasAnyValues(hash) {
  let result = false

  if (hash) {
    _.values(hash).map((val) => {
      if (val && (!_.isArray(val) || (!arrayEquals(val, []) && !arrayEquals(val, [''])))) {
        result = true
      }
    })
  }

  return result
}

export function applyFilter(f, e) {
  if (e) e.preventDefault()

  if (window.superContainer) window.superContainer.setState({ visible: false, object: {} })

  if (this.state.activeFilterUUID == f.uuid) {
    this.handleClearFilter(e)
  } else {
    let h = { search: '', search_not: '' }
    this.props.settings.filter.columns.forEach((i) => {
      if (i.format == 'range') {
        h[i.start_date_name] = ''
        h[i.end_date_name] = ''
        h[`${i.name}_period`] = ''
      } else if (i.format == 'number_range') {
        h[i.from_name] = ''
        h[i.to_name] = ''
      } else {
        h[i.name] = ''
      }
    })

    if (f.params) {
      Object.keys(f.params).map((key) => {
        if (key.includes("_ids") && Array.isArray(f.params[key]) && f.params[key].includes(null) && f.params[key].length == 1) {
          f.params[key] = [-1]
        }
      })
    }

    let filter = Object.assign(h, f.params)
    filter.filterId = f.id

    this.setState(
      {
        filter: filter,
        activeFilterUUID: f.uuid,
        columns_order: f.columns_order,
        columns_visibility: f.columns_visibility
      },
      () => {
        window.select2()
      }
    )
  }

  // let url = location.pathname + "?" + jQuery.param({date: moment(this.state.month).format("YYYY-MM-DD")}) + "&" + jQuery.param({filter: this.state.filter})
  // history.replaceState({filter: this.state.filter}, '', url)
}

export function handleFilterDelete(f, e) {
  e.preventDefault()

  let text = I18n.t('really-delete')
  if (f.shared_in_objects) {
    text += ` ${I18n.t('is-shared-in-objects-filter')}`
  } else if (f.shared) {
    text += ` ${I18n.t('is-shared-filter')}`
  }

  dataConfirmModal.confirm({
    title: I18n.t('modal.title'),
    text: text,
    zIindex: 10099,
    onCancel: () => {
      return false
    },
    onConfirm: () => {
      if (window.superContainer) window.superContainer.setState({ visible: false, object: {} })

      let filters = this.state.filters.filter((ff) => ff.uuid != f.uuid)
      this.setState({ filters: filters })
      let _this = this
      jQuery.ajax({
        method: 'DELETE',
        url: f.url,
        dataType: 'json',
        data: {
          system_default: f.system_default,
          kind: f.kind,
          system_name: f.system_name,
          scope_id: f.scope_id,
          scope_type: f.scope_type
        },
        complete: () => {
          window.app.refreshData() // need refresh to reload sidebar filters and tabs
        }
      })

      if (this.props.tabUUID) {
        if (window.tableFilters) {
          window.tableFilters[this.props.tabUUID] = filters
        } else {
          window.tableFilters = { [this.props.tabUUID]: filters }
        }
      }
    }
  })
}

export function showFilterForm(e) {
  e.preventDefault()

  let formFilter = (
    <FormFilter
      params={this.state.filter}
      columns={this.state.columns}
      userColumns={this.state.userColumns}
      tableView={this.state.tableView}
      type={this.props.settings.filter_name || pluralize(this.props.settings.type)}
      scopeType={this.props.scope_type}
      scopeId={this.props.scope_id}
      addFilter={this.addFilter.bind(this)}
    />
  )

  if (window.reactMagnificPopup) {
    window.reactMagnificPopup.setState({ visible: true, content: formFilter })
  } else {
    const magnific_popup_dom = document.getElementById('react-magnific-popup')
    if (magnific_popup_dom) {
      const root = createRoot(magnific_popup_dom)
      root.render(
        React.createElement(MagnificPopup, {
          content: formFilter,
          visible: true,
          size: 'tiny'
        })
      )
    }
  }
}

export function addFilter(data) {
  let filters
  if (this.state.filters.find((i) => i.id == data.id)) {
    filters = this.state.filters.map((i) => {
      if (i.id == data.id) {
        return data
      } else {
        return i
      }
    })
  } else {
    filters = this.state.filters.concat(data)
  }

  filters = filters.map((filter) => {
    if (
      filter.params.negated_filters &&
      (typeof filter.params.negated_filters === 'string' || filter.params.negated_filters instanceof String)
    ) {
      filter.params.negated_filters = filter.params.negated_filters.split(',')
    }
    if (
      filter.params.and_or_filters &&
      (typeof filter.params.and_or_filters === 'string' || filter.params.and_or_filters instanceof String)
    ) {
      filter.params.and_or_filters = filter.params.and_or_filters.split(',')
    }
    return filter
  })

  this.setState({
    filters: filters
  })

  if (this.props.tabUUID) {
    if (window.tableFilters) {
      window.tableFilters[this.props.tabUUID] = filters
    } else {
      window.tableFilters = { [this.props.tabUUID]: filters }
    }
  }
}

export function handleFilterColumnChange(e) {
  let columns = this.state.filterColumns.slice(0)
  let column
  columns = columns.map((i) => {
    if (i.name == e.target.name) column = i
    if (i.name == e.target.name) {
      this.updateColumnVisibility(i.name, !e.target.checked)
      return Object.assign(i, { hidden: !e.target.checked })
    } else {
      return i
    }
  })

  if (
    (!e.target.checked && this.state.filter[e.target.name]) ||
    (column && column.format == 'range') ||
    (column && column.format == 'number_range')
  ) {
    let filter = Object.assign({}, this.state.filter)
    if (column && column.format == 'range') {
      filter[column.start_date_name] = ''
      filter[column.end_date_name] = ''
    } else if (column && column.format == 'number_range') {
      filter[column.from_name] = ''
      filter[column.to_name] = ''
    } else {
      filter[e.target.name] = ''
    }

    this.setState({ filter: filter, filterColumns: columns, activeFilterUUID: '' }, () => {
      window.select2()
    })
  } else {
    this.setState({ filterColumns: columns }, () => {
      window.select2()
    })
  }
}

export function printElement(dom_id, config) {
  let content = document.getElementById(dom_id).outerHTML
  let h = Math.floor(document.getElementById(dom_id).height)
  let w = Math.floor(document.getElementById(dom_id).width)
  let url_vars = []
  let timetableScrollLeft = 0

  if ($('#timetable').length) timetableScrollLeft = $('#timetable')[0].scrollLeft

  content = content.replace(/wbs-to-dos hidden/g, 'wbs-to-dos')

  if (config.landscape) {
    url_vars.push('landscape=true')
  }

  let url = window.appData.print_element_url

  if (url_vars.length > 0) {
    url = url + `?${url_vars.join('&')}`
  }

  let win = window.open(
    url,
    'Caflou',
    'menubar=no,status=no,titlebar=no,location=no,toolbar=no,width=' + w + ',height=' + h + ',left=' + 0 + ',top=' + 0
  )

  win.onload = function () {
    $(win.document.body).find('#yield').html(content)
    if (timetableScrollLeft && timetableScrollLeft > 0 && $(win.document.body).find('#timetable').length) {
      $(win.document.body).find('#timetable')[0].scrollLeft = timetableScrollLeft
    }

    win.onafterprint = function () {
      win.close()
    }
    win.print()
  }
}

export function handleSuperDropdown({ e, dropdownMenu, dropdownRef, positionerRef, right }) {
  e.preventDefault()
  let coords = positionerRef.current.getBoundingClientRect()

  let superContainer = window.superContainer
  if (window.mobileLayout) {
    superContainer = window.superContainerMobile
    window.superContainer.setState({ visible: false })
  } else {
    window.superContainerMobile.setState({ visible: false })
  }

  superContainer.setState(
    {
      visible: true,
      object: dropdownMenu,
      objectVisible: false,
      x: 0,
      y: 0
    },
    () => {
      setTimeout(() => {
        let top = coords.top
        let helperScrollY = window.scrollY
        if (window.mobileLayout) {
          helperScrollY = document.querySelector('.master-container').scrollTop
          top -= superContainer.refs.container.getBoundingClientRect().top
        }

        let x = coords.left - 4
        let y = top + positionerRef.current.offsetHeight + window.scrollY
        if (right) {
          x = coords.left - dropdownRef.current.offsetWidth + positionerRef.current.offsetWidth + 4
        }

        if (
          top + positionerRef.current.offsetHeight + dropdownRef.current.offsetHeight + 48 > window.outerHeight &&
          top - 56 > dropdownRef.current.offsetHeight
        ) {
          y -= dropdownRef.current.offsetHeight + positionerRef.current.offsetHeight
          dropdownRef.current.classList.add('up')
        } else {
          dropdownRef.current.classList.remove('up')
        }

        superContainer.setState({
          objectVisible: true,
          y,
          x
        })

        window.magnify()
      }, 50)
    }
  )
}

export function createInvoiceFromProductModal(object = null) {
  let ids

  if (object) {
    ids = [object.id]
  } else {
    ids = this.state.checkedIds
  }

  return React.createElement(Modal, {
    title: I18n.t('create-invoice-common'),
    body: I18n.t('create-invoice-from-products-modal-text'),
    footer: (
      <React.Fragment>
        <button className="btn btn-default pull-left" data-dismiss="modal" type="button">
          {I18n.t('cancel')}
        </button>
        <a
          onClick={(e) => jQuery('#modal').modal('hide')}
          href={
            window.appData.new_invoice_path +
            '?' +
            jQuery.param({ product_ids: ids, filter: this.state.filter, kind: 'issued' })
          }
          className="btn btn-primary ajax-popup mb-8 btn-sized"
          data-popsize="middle"
        >
          {I18n.t('invoice')}
        </a>
        <a
          onClick={(e) => jQuery('#modal').modal('hide')}
          href={
            window.appData.new_invoice_path +
            '?' +
            jQuery.param({ product_ids: ids, filter: this.state.filter, kind: 'proforma' })
          }
          className="btn btn-primary ajax-popup mb-8 btn-sized"
          data-popsize="middle"
        >
          {I18n.t('proforma')}
        </a>
        <a
          onClick={(e) => jQuery('#modal').modal('hide')}
          href={
            window.appData.new_invoice_path +
            '?' +
            jQuery.param({ product_ids: ids, filter: this.state.filter, kind: 'offer' })
          }
          className="btn btn-primary ajax-popup mb-8 btn-sized"
          data-popsize="middle"
        >
          {I18n.t('offer')}
        </a>
        <a
          onClick={(e) => jQuery('#modal').modal('hide')}
          href={
            window.appData.new_invoice_path +
            '?' +
            jQuery.param({ product_ids: ids, filter: this.state.filter, kind: 'order_issued' })
          }
          className="btn btn-primary ajax-popup mb-8 btn-sized"
          data-popsize="middle"
        >
          {I18n.t('order')}
        </a>
        <a
          onClick={(e) => jQuery('#modal').modal('hide')}
          href={
            window.appData.new_invoice_path +
            '?' +
            jQuery.param({ product_ids: ids, filter: this.state.filter, kind: 'delivery' })
          }
          className="btn btn-primary ajax-popup mb-8 btn-sized"
          data-popsize="middle"
        >
          {I18n.t('delivery')}
        </a>
      </React.Fragment>
    )
  })
}

export function createInvoiceFromContractModal(kind, object = null) {
  let ids

  if (object) {
    ids = [object.id]
  } else {
    ids = this.state.checkedIds
  }

  return React.createElement(Modal, {
    title: I18n.t('create-invoice-common'),
    body: I18n.t('create-invoice-from-contract-modal-text'),
    footer: (
      <React.Fragment>
        <button className="btn btn-default pull-left" data-dismiss="modal" type="button">
          {I18n.t('cancel')}
        </button>
        <a
          onClick={(e) => jQuery('#modal').modal('hide')}
          href={window.appData.new_invoice_path + '?' + jQuery.param({ contract_id: ids, kind: kind })}
          className="btn btn-primary ajax-popup"
          data-popsize="middle"
        >
          {I18n.t('create-invoice-from-contract-sum')}
        </a>
        <a
          onClick={(e) => jQuery('#modal').modal('hide')}
          href={
            window.appData.new_invoice_path + '?' + jQuery.param({ contract_id: ids, kind: kind, items_merge: false })
          }
          className="btn btn-primary ajax-popup"
          data-popsize="middle"
        >
          {I18n.t('create-invoice-from-contract-by-items')}
        </a>
      </React.Fragment>
    )
  })
}

export function createInvoiceFromBudgetItemModal(object = null) {
  let ids

  if (object) {
    ids = [object.id]
  } else {
    ids = this.state.checkedIds
  }

  return React.createElement(Modal, {
    title: I18n.t('create-invoice-common'),
    body: I18n.t('create-invoice-from-products-modal-text'),
    footer: (
      <React.Fragment>
        <button className="btn btn-default pull-left" data-dismiss="modal" type="button">
          {I18n.t('cancel')}
        </button>

        {[
          ['issued', 'received', I18n.t('invoice_kinds.issued'), I18n.t('invoice_kinds.received')],
          ['proforma', 'proforma_received', I18n.t('proforma'), I18n.t('invoice_kinds.proforma_received')],
          ['offer', 'offer_received', I18n.t('offer'), I18n.t('invoice_kinds.offer_received')],
          ['order_issued', 'order_received', I18n.t('order'), I18n.t('invoice_kinds.order_received')],
          ['delivery', null, I18n.t('invoice_kinds.delivery'), null]
        ].map((i, index) => (
          <>
            <div className="btn-group">
              <a
                onClick={(e) => jQuery('#modal').modal('hide')}
                href={
                  window.appData.new_invoice_path +
                  '?' +
                  jQuery.param({
                    budget_item_ids: ids,
                    filter: this.state.filter,
                    kind: i[0],
                    scope_type: this.props.scope_type,
                    scope_id: this.props.scope_id
                  })
                }
                className="btn btn-primary ajax-popup mb-8 btn-sized"
                data-popsize="middle"
              >
                {i[2]}
              </a>

              {i[1] ? (
                <>
                  <button className="btn btn-primary dropdown-toggle" data-toggle="dropdown">
                    <span className="caret caret-down"></span>
                  </button>
                  <ul className="dropdown-menu dropdown-menu-right">
                    <li>
                      <a
                        onClick={(e) => jQuery('#modal').modal('hide')}
                        href={
                          window.appData.new_invoice_path +
                          '?' +
                          jQuery.param({
                            budget_item_ids: ids,
                            filter: this.state.filter,
                            kind: i[1],
                            scope_type: this.props.scope_type,
                            scope_id: this.props.scope_id
                          })
                        }
                        className="ajax-popup"
                        data-popsize="middle"
                      >
                        {i[3]}
                      </a>
                    </li>
                  </ul>
                </>
              ) : null}
            </div>
            {index == 2 ? <br /> : null}
          </>
        ))}
      </React.Fragment>
    )
  })
}

export function createInvoiceFromProductSetModal(object = null) {
  let ids

  if (object) {
    ids = [object.id]
  } else {
    ids = this.state.checkedIds
  }

  return React.createElement(Modal, {
    title: I18n.t('create-invoice-common'),
    body: I18n.t('create-invoice-from-products-modal-text'),
    footer: (
      <React.Fragment>
        <button className="btn btn-default pull-left" data-dismiss="modal" type="button">
          {I18n.t('cancel')}
        </button>
        <a
          onClick={(e) => jQuery('#modal').modal('hide')}
          href={
            window.appData.new_invoice_path +
            '?' +
            jQuery.param({ product_set_ids: ids, filter: this.state.filter, kind: 'issued' })
          }
          className="btn btn-primary ajax-popup mb-8 btn-sized"
          data-popsize="middle"
        >
          {I18n.t('invoice')}
        </a>
        <a
          onClick={(e) => jQuery('#modal').modal('hide')}
          href={
            window.appData.new_invoice_path +
            '?' +
            jQuery.param({ product_set_ids: ids, filter: this.state.filter, kind: 'proforma' })
          }
          className="btn btn-primary ajax-popup mb-8 btn-sized"
          data-popsize="middle"
        >
          {I18n.t('proforma')}
        </a>
        <a
          onClick={(e) => jQuery('#modal').modal('hide')}
          href={
            window.appData.new_invoice_path +
            '?' +
            jQuery.param({ product_set_ids: ids, filter: this.state.filter, kind: 'offer' })
          }
          className="btn btn-primary ajax-popup mb-8 btn-sized"
          data-popsize="middle"
        >
          {I18n.t('offer')}
        </a>
        <a
          onClick={(e) => jQuery('#modal').modal('hide')}
          href={
            window.appData.new_invoice_path +
            '?' +
            jQuery.param({ product_set_ids: ids, filter: this.state.filter, kind: 'order_issued' })
          }
          className="btn btn-primary ajax-popup mb-8 btn-sized"
          data-popsize="middle"
        >
          {I18n.t('order')}
        </a>
        <a
          onClick={(e) => jQuery('#modal').modal('hide')}
          href={
            window.appData.new_invoice_path +
            '?' +
            jQuery.param({ product_set_ids: ids, filter: this.state.filter, kind: 'delivery' })
          }
          className="btn btn-primary ajax-popup mb-8 btn-sized"
          data-popsize="middle"
        >
          {I18n.t('delivery')}
        </a>
      </React.Fragment>
    )
  })
}

export function hasUnreadComments(to_do) {
  return this.state.unread_object_ids && this.state.unread_object_ids.includes(to_do.id)
}

export function arrayEquals(a, b) {
  return Array.isArray(a) && Array.isArray(b) && a.length === b.length && a.every((val, index) => val === b[index])
}

export function handleActionScenario(scenario, object, e) {
  if (!scenario) return true
  let id = object.id

  e.preventDefault()
  switch (scenario) {
    case 'create-invoice-from-transfers':
      window.modalContainerRoot.render(
        React.createElement(Modal, {
          title: I18n.t('create-invoice'),
          scenario: scenario,
          checkedIds: [id],
          filter: this.state.filter,
          settings: this.props.settings,
          helperObject:
            this.props.settings.special && this.props.settings.special.helper_object
              ? this.props.settings.special.helper_object
              : {}
        })
      )
      break
    case 'toggle-deal-transfer':
      if (!object) return true

      jQuery.ajax({
        method: 'PATCH',
        url: object.url,
        dataType: 'script',
        data: {
          transfer: {
            done: !object.done,
            inline: true,
            skip_repeatable: true
          }
        },
        beforeSend: () => {
          this.setState({ loading: true })
        },
        success: (data) => {
          // console.log(data)
        },
        complete: () => {
          // this.setState({loading: false})
        }
      })
      break
    case 'toggle-read-email-message':
      if (!object) return true

      jQuery.ajax({
        method: 'POST',
        url: object.url + '/toggle_read',
        dataType: 'script',
        success: () => {
          window.hideSuperContainer()
        }
      })
      break
    case 'toggle-archive-email-message':
      if (!object) return true

      jQuery.ajax({
        method: 'POST',
        url: object.url + '/toggle_archive',
        dataType: 'script',
        success: () => {
          window.hideSuperContainer()
        }
      })
      break
    case 'upload-remote-update':
    case 'asset-remote-update':
      if (!object) return true

      jQuery.ajax({
        method: 'POST',
        url: (object.object_url || object.url) + '/remote_update',
        dataType: 'script',
        beforeSend: () => {
          window.hideSuperContainer()
          this.setState({ loading: true })
        },
        success: () => {
          this.setState({ loading: false })
        }
      })
      break
    case 'restore-email-message':
      if (!object) return true

      jQuery.ajax({
        method: 'POST',
        url: object.url + '/restore',
        dataType: 'script',
        success: () => {
          window.hideSuperContainer()
        }
      })
      break
    case 'make-real-uploads':
      if (!object) return true

      jQuery.ajax({
        method: 'POST',
        url: object.url + '/make_real_uploads',
        dataType: 'script',
        success: () => {
          window.postMessage({ type: 'reload_email_message' })
          window.hideSuperContainer()
        }
      })
      break
    case 'make-real-upload':
      if (!object) return true

      jQuery.ajax({
        method: 'POST',
        url: '/' + window.appData.account_slug + '/assets/' + object.id + '/make_real_upload',
        data: {
          email_message_id: this.props.scope_id
        },
        dataType: 'script',
        success: () => {
          window.postMessage({ type: 'reload_email_message' })
          window.hideSuperContainer()
        }
      })
      break
    case 'toggle-archive-company':
      if (!object) return true
      jQuery.ajax({
        method: 'PATCH',
        url: object.url,
        dataType: 'script',
        data: {
          company: {
            archived: !object.archived
          }
        }
      })
      break
    case 'create-in-teams':
      if (!object) return true
      jQuery.ajax({
        method: 'POST',
        url: object.url + '/create_teams',
        dataType: 'script'
      })
      break
    case 'create-slack-channel':
      if (!object) return true
      jQuery.ajax({
        method: 'POST',
        url: object.url + '/create_slack_channel',
        dataType: 'script'
      })
      break
    case 'toggle-to-do-finished':
      if (!object) return true
      jQuery.ajax({
        method: 'PATCH',
        url: object.url,
        dataType: 'script',
        data: {
          to_do: {
            finished: !object.finished
          }
        }
      })
      break
    case 'toggle-milestone-finished':
      if (!object) return true
      jQuery.ajax({
        method: 'PATCH',
        url: object.url,
        dataType: 'script',
        data: {
          milestone: {
            finished: !object.finished
          }
        }
      })
      break
    case 'toggle-complete-project':
      if (!object) return true

      jQuery.ajax({
        method: 'PATCH',
        url: object.url,
        dataType: 'script',
        data: {
          project: {
            finished: !object.finished,
            skip_repeatable: true
          }
        },
        beforeSend: () => {
          this.setState({ loading: true })
        }
      })
      break
    case 'toggle-complete-to-do':
      if (!object) return true

      jQuery.ajax({
        method: 'PATCH',
        url: object.url,
        dataType: 'script',
        data: {
          to_do: {
            finished: !object.finished
          }
        },
        beforeSend: () => {
          this.setState({ loading: true })
        }
      })
      break
    case 'product-copy-purchase-price-weight':
      if (!object) return true

      jQuery.ajax({
        method: 'PATCH',
        url: object.url + '/copy_purchase_price_weight',
        dataType: 'script',
        beforeSend: () => {
          this.setState({ loading: true })
        }
      })
      break
    case 'reset-product-weights':
      if (!object) return true

      dataConfirmModal.confirm({
        title: I18n.t('modal.title'),
        text: I18n.t('really-reset-weights'),
        zIindex: 10099,
        onCancel: () => {
          return false
        },
        onConfirm: () => {
          jQuery.ajax({
            method: 'PATCH',
            url: object.url + '/reset_price_weight',
            dataType: 'script',
            beforeSend: () => {
              this.setState({ loading: true })
            }
          })
        }
      })
      break
    case 'invoice-cancel-reminders':
      jQuery.ajax({
        method: 'POST',
        url: object.url + '/cancel_reminders',
        dataType: 'script',
        beforeSend: () => {
          this.setState({ loading: true })
          window.hideSuperContainer()
        },
        success: () => {
          window.postMessage({
            type: 'reload_table_data'
          })
        },
        complete: () => {
          this.setState({ loading: false })
        }
      })
      break
    case 'invoice-mark-as-paid':
      if (!object) return true
      jQuery.ajax({
        method: 'PATCH',
        url: object.url,
        dataType: 'script',
        data: {
          invoice: {
            paid: true
          }
        },
        beforeSend: () => {
          this.setState({ loading: true })
        }
      })
      break
    case 'invoice-toggle-paid':
      if (!object) return true

      window.modalContainerRoot.render(
        React.createElement(Modal, {
          title: I18n.t('modal.title'),
          scenario: scenario,
          helperObject: object,
          table: this
        })
      )

      break
    case 'toggle-complete-task':
      if (!object) return true
      const ajaxData = {
        method: 'PATCH',
        url: object.url,
        dataType: 'script',
        data: {
          form_finished_task_todos_step: 1,
          task: {
            finished: !object.finished,
            skip_repeatable: true
          }
        },
        beforeSend: () => {
          this.setState({ loading: true })
        }
      }

      if (
        !object.finished &&
        window.appData &&
        window.appData.account_settings.tasks_settings.finish_with_unfinished_todos == 'warning' &&
        object.has_unfinished_to_dos
      ) {
        dataConfirmModal.confirm({
          title: I18n.t('modal.title'),
          text: I18n.t('validate-finished-to-dos-warning-modal'),
          zIindex: 10099,
          onCancel: () => {
            return false
          },
          onConfirm: () => {
            jQuery.ajax(ajaxData)
          }
        })
      } else if (
        !object.finished &&
        window.appData &&
        window.appData.account_settings.tasks_settings.finish_with_unfinished_todos == 'denied' &&
        object.has_unfinished_to_dos
      ) {
        dataConfirmModal.confirm({
          title: I18n.t('modal.title'),
          text: I18n.t('validate-finished-to-dos'),
          zIindex: 10099,
          onCancel: () => {
            return false
          },
          onConfirm: () => {
            window.hideSuperContainer()
            return false
          }
        })
      } else {
        jQuery.ajax(ajaxData)
      }

      break
    case 'remove-from-timesheet':
      dataConfirmModal.confirm({
        title: I18n.t('modal.title'),
        text: I18n.t('remove-from-timesheet-confirmation'),
        zIindex: 10099,
        onCancel: () => {
          return false
        },
        onConfirm: () => {
          jQuery.ajax({
            method: 'DELETE',
            url: object.url + '/remove-from-timesheet',
            dataType: 'json',
            beforeSend: () => {},
            success: (data) => {
              window.postMessage({
                type: 'reload_table_data'
              })
            },
            complete: () => {}
          })
        }
      })
      break
    case 'track-time':
      if (!object) return true

      window.postMessage({ type: 'trackTime' })

      if (!this) {
        break
      }

      let timeEntry = {
        company_id: this.props.settings.type == 'company' ? object.id : object.company_id,
        project_id: this.props.settings.type == 'project' ? object.id : object.project_id,
        task_id: this.props.settings.type == 'task' ? object.id : object.task_id,
        to_do_id: this.props.settings.type == 'to_do' ? object.id : null,
        name: object.name
      }

      if (this.props.settings.type == 'task_todo') {
        if (object.object_type == 'task') {
          timeEntry = Object.assign(timeEntry, {
            task_id: object.id
          })
        } else if (!object.object_type || object.object_type == 'to_do') {
          timeEntry = Object.assign(timeEntry, {
            to_do_id: object.id
          })
        }
      }

      window.app.addEntry(timeEntry)
      window.hideSuperContainer()
      break
    case 'toggle-finish-to-do':
    case 'toggle-finish-milestone':
      if (!object) return true

      let sendData
      if (scenario == 'toggle-finish-milestone') {
        sendData = { milestone: { finished: !object.finished } }
      } else {
        sendData = { to_do: { finished: !object.finished } }
      }

      jQuery.ajax({
        method: 'PATCH',
        url: object.api_url,
        dataType: 'json',
        data: sendData,
        beforeSend: () => {
          this.setState({ loading: true })
        },
        success: () => {
          window.postMessage({
            type: 'reload_table_data'
          })
        },
        complete: () => {
          this.setState({ loading: false })
        }
      })
      break
    case 'create-invoice-from-products':
      window.modalContainerRoot.render(this.createInvoiceFromProductModal(object))
      break
    case 'create-invoice-from-contract':
      window.modalContainerRoot.render(this.createInvoiceFromContractModal('issued', object))
      break
    case 'create-invoice-from-contract-received':
      window.modalContainerRoot.render(this.createInvoiceFromContractModal('received', object))
      break
    case 'create-invoice-from-product-sets':
      window.modalContainerRoot.render(this.createInvoiceFromProductSetModal(object))
      break
    case 'create-invoice-from-budget-items':
      window.modalContainerRoot.render(this.createInvoiceFromBudgetItemModal(object))
      break
    case 'share':
      window.modalContainerRoot.render(
        React.createElement(Modal, {
          title: I18n.t('share'),
          beta: true,
          size: 'modal-lg',
          scenario: scenario,
          scope_type: this.props.settings.type,
          scope_id: object.id
        })
      )
      break
    case 'payment-pair-with-invoice':
      window.modalSelectorType = 'payment-pair-invoices'
      window.selectedPaymentId = object.id
      window.openModal(`/${window.appData.account_slug}/invoices?layout=modal_selector&choose_only_one=true`)
      break
    case 'payment-pair-with-transfer':
      window.modalSelectorType = 'payment-pair-transfers'
      window.selectedPaymentId = object.id
      window.openModal(`/${window.appData.account_slug}/transfers?layout=modal_selector&choose_only_one=true`)
      break
    case 'set-asset-default':
      if (!object) return true

      jQuery.ajax({
        method: 'PATCH',
        url: object.api_url,
        dataType: 'json',
        data: {
          asset: { default: true }
        },
        beforeSend: () => {
          this.setState({ loading: true })
        },
        success: () => {
          window.postMessage({
            type: 'reload_table_data'
          })
          window.postMessage({
            type: 'reload_detail_data'
          })
        },
        complete: () => {
          this.setState({ loading: false })
        }
      })
      break
    case 'trash-restore':
    case 'trash-delete':
      window.hideSuperContainer()

      dataConfirmModal.confirm({
        title: I18n.t('modal.title'),
        text: scenario == 'trash-restore' ? object.restore_warning : object.destroy_warning,
        zIindex: 10099,
        onCancel: () => {
          return false
        },
        onConfirm: () => {
          jQuery.ajax({
            method: scenario == 'trash-restore' ? 'POST' : 'DELETE',
            url: object.url,
            data: {
              id: object.id.split('*')[1],
              type: object.id.split('*')[0]
            },
            dataType: 'script',
            beforeSend: () => {
              this.setState({ loading: true })
            },
            success: () => {
              window.postMessage({
                type: 'reload_table_data',
                clearCheckedIds: true
              })
              window.app.refreshData()
            },
            complete: () => {
              this.setState({ loading: false })
            }
          })
        }
      })

      break
  }
}

export function handleSubscription(object, e) {
  e.preventDefault()

  jQuery.ajax({
    method: 'POST',
    url: window.appData.subscription_change_path,
    data: {
      id: object.id,
      type: this.props.settings.type
    },
    success: (data) => {
      Object.assign(object, data)
      this.forceUpdate()
      window.hideSuperContainer()
    }
  })
}

export function handleDelete(object, e) {
  e.preventDefault()
  let url = object.api_url

  // Fetch delete_warning message
  jQuery.ajax({
    method: 'GET',
    url: url,
    dataType: 'json',
    success: (data) => {
      dataConfirmModal.confirm({
        title: I18n.t('modal.title'),
        text: data.delete_warning,
        zIindex: 10099,
        onCancel: () => {
          window.hideSuperContainer()
          return false
        },
        onConfirm: () => {
          window.hideSuperContainer()
          if (data.immortal) return true

          if (this.state.objects) {
            this.setState({ objects: this.state.objects.filter((i) => i.id != object.id) })
          }

          jQuery.ajax({
            method: 'DELETE',
            url: object.model_name == 'Asset' ? object.api_url : object.url,
            dataType: 'json',
            beforeSend: () => {},
            success: (data) => {
              if (this.props.detail) {
                history.back()
              } else {
                window.postMessage({
                  type: 'reload_table_data'
                })

                if (window.reactCalendar) {
                  window.reactCalendar.fetchData(true)
                }
                window.postMessage({ type: 'reload_gantt' })
              }
            },
            complete: () => {
              window.app.refreshData() // need refresh to reload sidebar filters and tabs
            }
          })
        }
      })
    }
  })
}

export const renderComponent = ({ element, component, props, globalVariable }) => {
  if (!element && globalVariable) window[globalVariable] = undefined
  if (!element || element.dataset.reactComponentRendered) return

  let uuid = Helper.uuid()
  const root = createRoot(element)
  let propsHelper = props
  if (!propsHelper && element.dataset.props) {
    propsHelper = JSON.parse(element.dataset.props)
  }

  if (element.dataset.transformProps) {
    let camelizedPropsHelper = {}
    Object.keys(propsHelper).forEach((key) => {
      camelizedPropsHelper[camelCase(key)] = propsHelper[key]
    })

    propsHelper = camelizedPropsHelper
  }

  root.render(React.createElement(component, propsHelper))
  element.dataset.reactComponentRendered = true
  window.mountedComponents.push({
    uuid: uuid,
    root: root,
    element: element
  })

  if (globalVariable) {
    window[globalVariable] = element
    window[`${globalVariable}Root`] = root
  }
}

export const unmountComponents = () => {
  window.mountedComponents.forEach((component) => {
    try {
      component.root.unmount()
    } catch (error) {
      // console.log(error)
    }
  })

  window.mountedComponents = []
}

export const handleMissingAvatar = (e) => {
  if (!window.appData) {
    setTimeout(() => {
      handleMissingAvatar(e)
    }, 200)
    return
  }
  if (e.target.src == window.appData.default_avatar_url) return

  e.target.src = window.appData.default_avatar_url
}
